module.exports = __webpack_public_path__ + "img/3.95cc3730.png";